export const prebidConfig = {
  enableTIDs: true,
  debug: false,
  enableSendAllBids: true, // Sends all bids, not just the highest one
  bidderSequence: "random",
 

  // **Client-Side Bidders (Cookie-Based SSPs in Prebid.js)**
  bidders: ["smartyads", "bitmedia"],

  // **Server-to-Server (Prebid Server) Configuration**
  s2sConfig: {
    accountId: "your-prebid-account",
    enabled: true,
    bidders: ["districtm"],
    timeout: 1500,
    endpoint: "https://localhost:8443/openrtb2/auction",
    syncEndpoint: "https://localhost:8443/cookie_sync",
    adapter: "prebidServer",
    debug: true,
    bidderControl: {
      districtm: {
        bidSource: { server: 0, client: 100 },
        includeSourceKvp: true
      }
    }
  },

  // **Testing Server-to-Server (S2S) Bidders**
  s2sTesting: {
    enabled: true,
    bidders: ["districtm"], // Ensures all S2S bidders are tested
    bidResponse: {
      cpm: 2.50,
      currency: "USD",
      width: 300,
      height: 250,
      ad: "<html><body><h1>Test Ad</h1></body></html>"
    }
  },

  // **Auction Settings**
  bidderTimeout: 1200, // Adjusted to prevent unnecessary timeouts

  // **Floor Pricing Configuration**
    floors: {
        enabled: true,
        enforcement: { enforceJS: true, enforcePBS: true },
        auctionDelay: 50,
        data: {
          currency: "USD",
          modelVersion: "1.0",
          schema: {
                fields: [ 'mediaType', 'adUnitCode' ]
            },
          values: {
            "banner|inarticle-paragraph3": 0.20, 
            "banner|navbar-ad": 0.20,
            "banner|sidebar-top": 0.20

          },
          "default": 0.19
        }
    },

  // **Supply Chain Object (for Ad Transparency)**
  schain: {
    config: {
      ver: "1.0", // Version of schain
      complete: 1, // 1 = all intermediaries are included in the chain
      nodes: [
        { asi: "smartyads.com", sid: "xxx", hp: 1 },
        { asi: "bitmedia.io", sid: "yyy", hp: 1 }
      ]
    } 
  },

  // **GDPR, GPP & CCPA Support**
  consentManagement: {
    gdpr: {
      cmpApi: "iab",
      timeout: 1000,
      defaultGdprScope: true
    },
    usp: {
      cmpApi: "iab",
      timeout: 1000
    },
    gpp: {
      enabled: true,
      cmpApi: "iab",
      timeout: 1000
    },
    allowAuctionWithoutConsent: true, // Prevents Prebid from blocking if CMP is missing
  },

  // **Children's Online Privacy Protection Act (COPPA) Compliance**
  coppa: 0,

  userSync: {
    syncEnabled: true, 
    filterSettings: {
      iframe: { bidders: '*', filter: 'include' }, 
      image: { bidders: '*', filter: 'exclude' }  //Disable image syncs (to limit tracking)
    },
    syncDelay: 3000,  // Delay sync to avoid performance issues
    maxRequestsPerOrigin: 2 // Prevent excessive sync requests
  }

};
